import React from 'react';
import CombinedShippingIcon from '@tradera/blueprint/theme/icons2/combined-shipping.svg?jsx';
import { useTranslator } from 'tradera-lang/translate';
import styles from './combined-shipping-badge.module.scss';
import { useSelector } from 'react-redux';

const CombinedShippingBadge = ({
    days,
    position,
    className = '',
    freeShippingCostLimit,
    compact,
    disableFreeShippingCostLimit = false
}) => {
    const { t } = useTranslator();

    const isAutoCalcPriceShippingSettings = useSelector(
        state =>
            state.environment.featureSwitches[
                'auto-calc-price-shipping-settings'
            ]
    );

    return (
        <div
            className={`${className} ${
                position === 'top' ? 'top-center' : ''
            }`}>
            <div
                className={`d-inline-flex flex-column ${
                    compact ? 'flex-md-column' : 'flex-md-row'
                }`}>
                <div
                    className={`d-inline-flex align-items-center bg-primary ${styles.combinedShippingBadge}`}>
                    <CombinedShippingIcon
                        className={`mr-1 icon-white icon ${styles.iconRelativeSize}`}
                    />
                    <strong>{t('combinedShippingBadge_title')}</strong>
                    {days !== undefined && (
                        <span>
                            {' '}
                            {t('combinedShippingBadge_count_days', {
                                count: days
                            })}
                        </span>
                    )}
                </div>
                {freeShippingCostLimit !== undefined &&
                    isAutoCalcPriceShippingSettings &&
                    !disableFreeShippingCostLimit && (
                        <div
                            className={`d-inline-flex ${
                                compact ? styles.compact : 'd-md-inline'
                            } justify-content-center align-items-center bg-success ${
                                styles.combinedShippingBadge
                            } ${styles.combinedShippingBadgeShipping}`}>
                            <span className="size-oslo">
                                {t(
                                    'combinedShippingBadge_x_freeShippingCostLimit',
                                    {
                                        freeShippingCostLimit
                                    }
                                )}
                            </span>
                        </div>
                    )}
            </div>
        </div>
    );
};

export { CombinedShippingBadge };
